import React, { forwardRef, memo } from 'react';
import cn from 'classnames';

import { Button } from 'components/form';
import ButtonV3 from 'components/ComponentV2/ButtonV3';
import styles from './BannerUpload.module.scss';

export interface BannerUploadProps {
  className?: string;
  image: string;
  alt: string;
  title?: string;
  buttonClassName?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  color?:
    | 'primary'
    | 'primary-light'
    | 'primary-faint'
    | 'secondary'
    | 'danger'
    | 'white'
    | 'black';
}

export const BannerUpload: React.FC<BannerUploadProps> = memo(
  forwardRef<HTMLInputElement, BannerUploadProps>(
    (
      {
        className = '',
        color = 'primary-light',
        title,
        buttonClassName,
        onChange,
        ...props
      },
      ref
    ) => {
      const contentClassNames = cn(styles.container, className);
      const buttonClassNames = cn(styles.button, buttonClassName);

      //reseting value of input on click so that onChange event is fired even if the same file is selected
      const onInputClick = (
        event: React.MouseEvent<HTMLInputElement, MouseEvent>
      ) => {
        const element = event.target as HTMLInputElement;
        element.value = '';
      };

      return (
        <div className={contentClassNames} data-testid="BannerUpload">
          <input
            type="file"
            accept="image/*"
            id="upload-banner-image"
            ref={ref}
            onChange={onChange}
            hidden
            onClick={onInputClick}
            {...props}
          />
          {isSecureContext ? (
            <ButtonV3
              variant="contained"
              color="secondary"
              type="button"
              className={styles.bannerCoverButton}
            >
              <label htmlFor="upload-banner-image">
                {title || 'Upload banner image'}
              </label>
            </ButtonV3>
          ) : (
            <Button type="button" color={color} className={buttonClassNames}>
              <label htmlFor="upload-banner-image">
                {title || 'Upload banner image'}
              </label>
            </Button>
          )}
        </div>
      );
    }
  )
);

BannerUpload.displayName = 'BannerUpload';
